(function($) {

    'use strict';

    var galleries = [];

    var init = function() {
        $('.main-nav .burger').on('click', toggleMenu);
        $('.main-nav__menu .menu-item-has-children').on('click', toggleSubMenu);
    };

    var toggleSubMenu = function(e){
        if(window.innerWidth < 992 && $(e.target).closest('li').hasClass('menu-item-has-children')){
            e.preventDefault();
            var item = $(e.currentTarget);
            item.toggleClass('open');
            item.find('.sub-menu').slideToggle(200, 'swing');
        }
    }

    var toggleMenu = function(){
        $('.main-nav__menu, .main-nav .burger').toggleClass('open');
    }

    $(document).ready(function() {
        init();
    });

})(jQuery);
